<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      &nbsp;
    </p>
    <div class="form-list-usaha">
      <div v-for="(item, index) in items" :key="index">
        <p v-html="item"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items'],
}
</script>
